import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSchool } from '../context/SchoolContext';
import { getImageUrl } from '../utils/axios';
import logoHorizontal from '../assests/logo-horizontal.png';
import logoIcon from '../assests/logo-icon.png';

const Sidebar = ({ isCollapsed, setIsCollapsed }) => {
  const { user } = useAuth();
  const { school } = useSchool();
  const location = useLocation();



  const isActive = (path) => location.pathname === path;

  // Grouped Menu Structure inspired by PreSkool & Scholix ERP
  const menuGroups = [
    {
      title: 'Main',
      items: [
        {
          label: 'Dashboard',
          icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
          ),
          path: user?.role === 'teacher' ? '/dashboard/teacher' : user?.role === 'student' ? '/dashboard/student' : user?.role === 'parent' ? '/parent/dashboard' : '/dashboard/admin'
        },
        {
          label: 'Admissions & Applications',
          icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          ),
          path: '/admissions'
        }
      ]
    },
    {
      title: 'Peoples',
      items: [
        {
          label: 'Students',
          icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M12 14l9-5-9-5-9 5 9 5z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0112 20.055a11.952 11.952 0 01-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
            </svg>
          ),
          path: '/students'
        },
        {
          label: 'Parents & Guardians',
          icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          ),
          path: '/parent/dashboard'
        },
        {
          label: 'Teachers & HR',
          icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6a4 4 0 11-8 0 4 4 0 018 0zm-7 12a6 6 0 016-6h2a6 6 0 016 6v1H9v-1z" />
            </svg>
          ),
          path: '/staff'
        }
      ]
    },
    {
      title: 'Academic',
      items: [
        {
          label: 'Class Attendance',
          icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          ),
          path: '/attendance/mark'
        },
        {
          label: 'Class Routine & Timetable',
          icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          ),
          path: '/timetable'
        },
        {
          label: 'Examinations & Marks',
          icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
          ),
          path: '/exams'
        },
        {
          label: 'AI Test Generator',
          icon: (
            <svg className="w-5 h-5 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          ),
          path: '/ai-tests'
        },
        {
          label: 'Student ID Cards',
          icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 012-2h2a2 2 0 012 2v1m-4 0h4" />
            </svg>
          ),
          path: '/idcards'
        }
      ]
    },
    {
      title: 'Financials & Fees',
      items: [
        {
          label: 'Fees Collection',
          icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          ),
          path: '/fees'
        },
        {
          label: 'Fee Defaulters List',
          icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          ),
          path: '/fees/defaulters'
        },
        {
          label: 'Staff Payroll',
          icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          ),
          path: '/staff/payroll'
        }
      ]
    },
    {
      title: 'Administration',
      items: [
        {
          label: 'Reports & Analytics',
          icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
          ),
          path: '/reports'
        },
        ...(user?.role === 'super_admin'
          ? [
              {
                label: 'Super Admin HQ ⚡',
                icon: (
                  <svg className="w-5 h-5 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                  </svg>
                ),
                path: '/admin/hub'
              }
            ]
          : [
              {
                label: 'User Management',
                icon: (
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                ),
                path: '/settings/users'
              },
              {
                label: 'School Settings',
                icon: (
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                  </svg>
                ),
                path: '/settings'
              },
              {
                label: 'White-Label Branding',
                icon: (
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
                  </svg>
                ),
                path: '/branding'
              }
            ])
      ]
    }
  ];

  const isLocked = (path) => {
    if (user?.role === 'super_admin') return false;
    if (path === '/ai-tests' && school?.feature_ai_test_gen === 0) return true;
    if (path === '/timetable' && school?.feature_timetable === 0) return true;
    if (path === '/idcards' && school?.feature_id_cards === 0) return true;
    return false;
  };

  return (
    <aside
      className={`fixed top-0 left-0 z-40 h-screen bg-white border-r border-purple-100 transition-all duration-300 flex flex-col ${
        isCollapsed ? 'w-20' : 'w-64'
      } shadow-purple-subtle print:hidden`}
    >
      {/* Top App Header & Logo */}
      <div className="h-16 px-4 flex items-center justify-between border-b border-purple-100/80">
        <Link to="/" className="flex items-center space-x-2.5 overflow-hidden">
          {isCollapsed ? (
            <img src={logoIcon} alt="Logo Icon" className="h-9 w-auto object-contain shrink-0" />
          ) : (
            <img src={logoHorizontal} alt="MarkazSchool Pro" className="h-9 w-auto object-contain shrink-0" />
          )}
        </Link>
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="p-1.5 rounded-lg text-slate-400 hover:text-purple-700 hover:bg-purple-50 transition"
          title={isCollapsed ? 'Expand Sidebar' : 'Collapse Sidebar'}
        >
          <svg className={`w-5 h-5 transition-transform duration-200 ${isCollapsed ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
          </svg>
        </button>
      </div>

      {/* Client School & Branch Card */}
      {!isCollapsed && (
        <div className="p-2.5 mx-3 my-2 bg-purple-50/70 rounded-2xl border border-purple-100/80 flex items-center justify-between shadow-sm">
          <div className="flex items-center space-x-2.5 overflow-hidden">
            <div className="w-8 h-8 rounded-xl bg-white text-purple-700 flex items-center justify-center font-bold text-xs shadow-xs shrink-0 border border-purple-100 overflow-hidden">
              {school?.logo ? (
                <img
                  src={getImageUrl(school.logo)}
                  alt="Logo"
                  className="w-full h-full object-contain p-0.5"
                  onError={(e) => { e.target.style.display = 'none'; }}
                />
              ) : (
                '🏫'
              )}
            </div>
            <div className="truncate leading-tight">
              <p className="text-[9px] text-purple-600 font-extrabold uppercase tracking-wider">
                {user?.role === 'super_admin' ? 'SUPER ADMIN CONTROL' : 'CLIENT INSTITUTE'}
              </p>
              <p
                className="text-xs font-extrabold text-slate-900 truncate"
                title={user?.role === 'super_admin' ? 'MarkazSchool Pro HQ' : (school?.name || 'School Portal')}
              >
                {user?.role === 'super_admin' ? 'MarkazSchool Pro HQ' : (school?.name || 'School Portal')}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Navigation Scroll List */}
      <div className="flex-1 overflow-y-auto px-3 py-2 space-y-5 scrollbar-thin">
        {menuGroups.map((group, idx) => (
          <div key={idx} className="space-y-1">
            {!isCollapsed && (
              <p className="px-3 text-[10px] font-bold text-purple-400 uppercase tracking-widest mb-1.5">
                {group.title}
              </p>
            )}
            {group.items.map((item, itemIdx) => {
              const active = isActive(item.path);
              const locked = isLocked(item.path);
              return (
                <Link
                  key={itemIdx}
                  to={item.path}
                  onClick={(e) => {
                    if (locked) {
                      e.preventDefault();
                      alert('🔒 This feature is locked under your current plan tier.\n\nTo upgrade your plan, please contact Support on WhatsApp: +92 317 1818108 or email waleed.khalid111@gmail.com');
                    }
                  }}
                  className={`flex items-center justify-between px-3 py-2.5 rounded-xl text-xs font-semibold transition ${
                    active
                      ? 'bg-purple-600 text-white shadow-purple-glow'
                      : locked
                      ? 'text-slate-400 bg-slate-50/60 hover:bg-amber-50 hover:text-amber-800'
                      : 'text-slate-600 hover:bg-purple-50/80 hover:text-purple-800'
                  }`}
                  title={isCollapsed ? (locked ? `${item.label} (Locked Pro)` : item.label) : undefined}
                >
                  <div className="flex items-center space-x-3 truncate">
                    <span className={`shrink-0 ${active ? 'text-white' : locked ? 'text-amber-500' : 'text-purple-600'}`}>
                      {item.icon}
                    </span>
                    {!isCollapsed && <span className="truncate">{item.label}</span>}
                  </div>
                  {!isCollapsed && locked && (
                    <span className="text-[10px] bg-amber-100 text-amber-800 font-extrabold px-1.5 py-0.5 rounded border border-amber-200 shrink-0">
                      🔒 PRO
                    </span>
                  )}
                </Link>
              );
            })}
          </div>
        ))}
      </div>

      {/* Footer User Profile Summary */}
      <div className="p-3 border-t border-purple-100 bg-purple-50/30">
        <div className="flex items-center space-x-3">
          <div className="w-9 h-9 rounded-xl bg-purple-700 text-white font-bold flex items-center justify-center text-sm shrink-0 shadow-sm">
            {user?.name ? user.name.charAt(0).toUpperCase() : 'A'}
          </div>
          {!isCollapsed && (
            <div className="truncate text-left leading-tight">
              <p className="text-xs font-bold text-slate-800 truncate">{user?.name || 'Administrator'}</p>
              <p className="text-[10px] text-purple-600 font-semibold uppercase">{user?.role || 'Admin'}</p>
            </div>
          )}
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
